import React from 'react';
import './wildlife.css';

function WildLife() {
  const wildlifeAreas = [
    { name: "Yala National Park", 
      highlight: "Best for leopard sightings", 
      image: "/yala national.jpg" },

    { name: "Wasgamuwa National Park", 
      highlight: "Elephant gathering spot", 
      image: "/wasgamuwa.jpg" },

    { name: "Wilpattu National Park", 
      highlight: "Ancient lakes & leopards", 
      image: "/wilpattu.jpg" },

    { name: "Uda Walawe National Park", 
      highlight: "Elephant paradise", 
      image: "/udawala.jpg" },

    { name: "Bundala National Park", 
      highlight: "Coastal wildlife sanctuary", 
      image: "/bundala1.jpg" },

    { name: "Gal Oya National Park", 
      highlight: "Boat safaris & elephants", 
      image: "/galoya.jpg" },

    { name: "Horton Plains", 
      highlight: "Mountain wildlife", 
      image: "/hort.jpg" },

    { name: "Sinharaja Forest", 
      highlight: "UNESCO rainforest", 
      image: "/sinharaja.jpg" },

    { name: "Kaudulla Nature Reserve", 
      highlight: "Elephant corridor", 
      image: "/kaudulla.jpg" },

    { name: "Maduru Oya National Park", 
      highlight: "Ancient civilization sites", 
      image: "/maduru oya national.jpg" },

    { name: "Minneriya National Park", 
      highlight: "The Gathering of elephants", 
      image: "/minneriya.jpg" }
  ];

  return (
    <div className="wildlife-container">
      {/* Main Banner - Same as before */}
      <div className="banner-section">
        <div className="banner-overlay"></div>
        <img 
          src="/wild-banner.jpeg" 
          alt="Wildlife Safari Adventure" 
          className="banner-image"
        />
        <div className="banner-content">
          <h1 className="banner-title animate-fade-in">
            <span><b>Wildlife</b></span>  Safaris
          </h1>
          <div className="banner-description animate-slide-up">
            <p>
              Experience the thrill of encountering majestic elephants, elusive leopards, 
              and Sri Lanka's iconic wildlife in their natural habitat. Our expert-guided 
              safaris offer unforgettable close encounters with nature's most magnificent 
              creatures.
            </p>
            <button className="book-now-btn animate-pulse">
              Book Your Safari Now
            </button>
          </div>
        </div>
      </div>

      {/* Wildlife Areas Section */}
      <div className="wildlife-areas-section">
        <h2 className="section-title">Explore Sri Lanka's Wildlife Parks</h2>
        <p className="section-subtitle">Home to leopards, elephants and diverse ecosystems</p>
        
        <div className="wildlife-areas-grid">
          {wildlifeAreas.map((area, index) => (
            <div className="wildlife-area-card" key={index}>
              <div className="area-image-container">
                <img 
                  src={area.image} 
                  alt={area.name} 
                  className="area-image"
                  loading="lazy"
                />
                <div className="area-overlay"></div>
              </div>
              <div className="area-info">
                <h3>{area.name}</h3>
                <p>{area.highlight}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Image Carousel - Same as before */}
      <div className="carousel-section">
        <h2 className="carousel-title">Our Wildlife Encounters</h2>
        <div className="carousel-container">
          <div className="carousel-slide">
            <img src="/elephant.jpg" alt="Elephant Safari" />
            <div className="slide-overlay">
              <h3>Elephant Expeditions</h3>
              <p>Witness gentle giants in their natural domain</p>
            </div>
          </div>
          <div className="carousel-slide">
            <img src="/leopard.jpg" alt="Leopard Safari" />
            <div className="slide-overlay">
              <h3>Leopard Tracking</h3>
              <p>Spot the elusive predators of the savannah</p>
            </div>
          </div>
          <div className="carousel-slide">
            <img src="/premium.jpg" alt="Safari Experience" />
            <div className="slide-overlay">
              <h3>Premium Safari Experience</h3>
              <p>Luxury lodges with wildlife at your doorstep</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default WildLife;